import { Injectable, Inject } from '@angular/core';
import { DataService } from '../../shared-service/data.service';
import { BaseService }   from '../../shared-service/base.service';

@Injectable()
export class OverviewService {

	constructor(private ds: DataService, private bs: BaseService) {}

	getOverViewUserProfileData(body: Object, key: PropertyKey) {
		return new Promise((resolve, reject) => {
			this.ds.doPostWithPromise(key, 'OverView/GetOverViewUserProfile', body).then((data) => {
				resolve(data);
			}, (err) => {
				reject(err);
			});
		});
	}

	getOverViewMyTaskData(body: Object, key: PropertyKey) {
		return new Promise((resolve, reject) => {
			this.ds.doPostWithPromise(key, 'OverView/GetOverViewMytask', body).then((data) => {
				resolve(data);
			}, (err) => {
				reject(err);
			});
		});
	}
	getOverViewUpcomingTraining(body: Object, key: PropertyKey) {
		let promise = new Promise((resolve, reject) => {
			let controllerMethod = 'OverView/GetOverViewUpcomingTraining';
			this.ds.doPostWithPromise(key, controllerMethod, body).then((data) => {
				this.bs.log('info', "Succes in getting result from " + controllerMethod);
				resolve(data);
			}, (err) => {
				this.bs.log('error', err);
				this.bs.errorHandler(JSON.parse(err.error).Message);
				reject(err);
			}).catch((exception) => {
				this.bs.errorHandler(exception);
				reject(exception);
			});
		});
		return promise;
	};

	getFileControlDetailsServer(body: Object, key: PropertyKey|null) {
		return new Promise((resolve, reject) => {
			this.ds.doPostWithPromise(key, 'FileUpload/GetFileControlDetails', body).then((data) => {
				resolve(data);
			}, (err) => {
				reject(err);
			});
		});
	}
	getUserTimeLineTiles(body: Object, key: PropertyKey) {
		return new Promise((resolve, reject) => {
			this.ds.doPostWithPromise(key, 'OverView/GetUserTimeLineTiles', body).then((data) => {
				resolve(data);
			}, (err) => {
				reject(err);
			});
		});
	}

	getMoreComments(body: Object, key: PropertyKey) {
		return new Promise((resolve, reject) => {
			this.ds.doPostWithPromise(key, 'OverView/GetUserTimeLineConversationList', body).then((data) => {
				resolve(data);
			}, (err) => {
				reject(err);
			});
		});
	}


	
	AddUpdateDeleteComment(body: Object, key: PropertyKey) {
		return new Promise((resolve, reject) => {
			this.ds.doPostWithPromise(key, 'OverView/InsertUpdateDeleteConversationComments', body).then((data) => {
				resolve(data);
			}, (err) => {
				reject(err);
			});
		});
	}
	GetFirstComment(body: Object, key: PropertyKey) {
		return new Promise((resolve, reject) => {
			this.ds.doPostWithPromise(key, 'OverView/GetLatestConversationComment', body).then((data) => {
				resolve(data);
			}, (err) => {
				reject(err);
			});
		});
	}

	
	LikeUpdateOverTimeLineConversation(body: Object, key: PropertyKey) {
		return new Promise((resolve, reject) => {
			this.ds.doPostWithPromise(key, 'OverView/LikeUpdateOverTimeLineConversation', body).then((data) => {
				resolve(data);
			}, (err) => {
				reject(err);
			});
		});
	}
	SetTimeLineReportedAbuseComment(body: Object, key: PropertyKey) {
		return new Promise((resolve, reject) => {
			this.ds.doPostWithPromise(key, 'OverView/SetTimeLineReportedAbuseComment', body).then((data) => {
				resolve(data);
			}, (err) => {
				reject(err);
			});
		});
	}
	LikeUpdateOverTimeLine(body: Object, key: PropertyKey) {
		return new Promise((resolve, reject) => {
			this.ds.doPostWithPromise(key, 'OverView/LikeUpdateOverTimeLine', body).then((data) => {
				resolve(data);
			}, (err) => {
				reject(err);
			});
		});
	}

	RemoveTimeLineTile(body: Object, key: PropertyKey) {
		return new Promise((resolve, reject) => {
			this.ds.doPostWithPromise(key, 'OverView/RemoveTimeLineTile', body).then((data) => {
				resolve(data);
			}, (err) => {
				reject(err);
			});
		});
	}
	BlockUserTimeLineTiles(body: Object, key: PropertyKey) {
		return new Promise((resolve, reject) => {
			this.ds.doPostWithPromise(key, 'OverView/BlockUserTimeLineTiles', body).then((data) => {
				resolve(data);
			}, (err) => {
				reject(err);
			});
		});
	}
	getBlockedUserList(body: Object, key: PropertyKey) {
		return new Promise((resolve, reject) => {
			this.ds.doPostWithPromise(key, 'OverView/BlockedUserList', body).then((data) => {
				resolve(data);
			}, (err) => {
				reject(err);
			});
		});
	}
	getUnBlockedSelectedUser(body: Object, key: PropertyKey) {
		return new Promise((resolve, reject) => {
			this.ds.doPostWithPromise(key, 'OverView/UnblockedSelectedUser', body).then((data) => {
				resolve(data);
			}, (err) => {
				reject(err);
			});
		});
	}

	DeleteTimeLineTile(body: Object, key: PropertyKey) {
		return new Promise((resolve, reject) => {
			this.ds.doPostWithPromise(key, 'OverView/DeleteTimeLineTile', body).then((data) => {
				resolve(data);
			}, (err) => {
				reject(err);
			});
		});
	}
	
	
}
